import React, { useState, useEffect, useRef } from "react";

// Components
import { Button, Columns } from 'react-bulma-components';
import CompanyBg from 'shared/media/company-list-bg.svg';
import Loading from "shared/components/loading/Loading";
import CompanyDetailPanel from "./CompanyDetailPanel";
import { Trash2 } from 'react-feather';

// actions
import { makeAPIRequest } from "shared/state/fetch";
import { useTokenStatus } from "shared/state/auth/actions";

// Styles
import styles from './Companies.module.scss';

const Companies = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [companiesList, setCompaniesList] = useState([]);
    const [shouldFetch, setShouldFetch] = useState(true);
    const [isDetailActive, setIsDetailActive] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState('');
    const { handleTokenStatus } = useTokenStatus();
    const isMounted = useRef(null);
    
    useEffect(() => {
        isMounted.current = true;

        if(shouldFetch){
            makeAPIRequest('companies')
                .then(response => {
                    if (isMounted.current) {
                        setShouldFetch(false);
                        setIsLoading(false);
                        setCompaniesList(response.result.data);
                        response.status && handleTokenStatus(response);
                    }
                }
            );
        }

        return () => {
            // executed when unmount
            isMounted.current = false;
        }
    }, [shouldFetch]); // empty dependency array means this effect will only run once

    const handleSelectedCompany = (company) => {
        setIsDetailActive(true);
        setSelectedCompany(company);
    }

    const handleAfterSave = ({ shouldFetch }) => {
        setShouldFetch(shouldFetch);
    }

    const handleRemoveCompany = (company) => {
        alert('remove ', company.name);

    }

    const handleClose = () => {
        setIsDetailActive(false);
        setSelectedCompany(false);
    }


    return (
        <>
        { // Wait for fetch beforing showing components depending on that data
            !isLoading &&
            <CompanyDetailPanel
                afterSave={ handleAfterSave }
                company={ selectedCompany }
                isActive={ isDetailActive }
                onClose={ handleClose }
                />
        }

        <section className={ styles.companies }>
            <div className="pageHeading">
                <h1>Companies</h1>
                <Button size="small" disabled className="gradient">
                    New Company
                </Button>
            </div>
            { (!companiesList || companiesList.length === 0) && !isLoading &&
                <Columns>
                    <Columns.Column size={4} style={{ position: 'relative'}}>
                        <p style={{ paddingLeft: '3.5rem'}}>No Companies to display</p>
                    </Columns.Column>
                    <Columns.Column>
                        <div className="section" style={{
                            height: '80%',
                            display: 'flex',
                            alignItems: 'center',
                            borderLeft: '1px solid #D2D4DA'
                        }}>
                         <figure style={{ flex: 1, width: 'auto'}}>
                             <img src={CompanyBg} alt="Illustration" role="presentation" />
                         </figure>
                     </div>
                    </Columns.Column>
                </Columns>
            }
            { companiesList && companiesList.length > 0 &&
                    <table className="table is-hoverable is-fullwidth">
                        <thead>
                            <tr>
                                <td></td>
                                <td><strong>Company Name</strong></td>
                                <td><strong>City</strong></td>
                                <td><strong>Business Sector</strong></td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            { companiesList.map((company, index) => {
                                // in case of no image

                                return <tr key={ index }>
                                    <td></td>
                                    <td className="has-text-left"
                                        onClick={ ()=> handleSelectedCompany(company) }
                                        style={{ verticalAlign: 'middle', cursor: 'pointer' } }>
                                        { company.name } { company.surname  }
                                    </td>
                                    <td className="has-text-left" style={{ verticalAlign: 'middle' }}>
                                        { company.city }
                                    </td>
                                    <td className="has-text-left" style={{ paddingLeft: '1.5rem', verticalAlign: 'middle' }}>
                                        { company.business_sector }
                                    </td>
                                    <td className="has-text-right"
                                        style={{paddingRight: '5rem', verticalAlign: 'middle'}}>
                                        <Button
                                            className={ styles.delete }
                                            text
                                            onClick={ ()=> handleRemoveCompany(company) } >
                                            <Trash2 size={18} strokeWidth={1.5} />
                                        </Button>
                                    </td>

                                </tr>
                            })}
                        </tbody>
                    </table>
                }
        </section>
        <Loading isLoading={ isLoading && companiesList.length === 0 }/></>
    );
}

export default Companies;
